// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-create-placeholder {
  padding: var(--dp-spacing-md);
}

.dp-create-placeholder h3 {
  margin: 0 0 var(--dp-spacing-xs);
  font-size: var(--dp-font-size-md);
  color: var(--dp-color-text);
}

.dp-create-placeholder__desc {
  margin: 0 0 var(--dp-spacing-md);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text-secondary);
}

.dp-create-placeholder__form {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-sm);
  margin-bottom: var(--dp-spacing-md);
}

.dp-create-placeholder__label {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-xs);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text);
  font-weight: var(--dp-font-weight-semibold);
}

.dp-create-placeholder__input,
.dp-create-placeholder__select {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-normal);
  color: var(--dp-color-text);
  background: var(--dp-color-bg);
}

.dp-create-placeholder__input:focus,
.dp-create-placeholder__select:focus {
  outline: none;
  border-color: var(--dp-color-primary);
  box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.15);
}

.dp-create-placeholder__checkbox-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--dp-spacing-xs);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
}

.dp-create-placeholder__checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--dp-color-primary);
}

.dp-create-placeholder__btn {
  width: 100%;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border: none;
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
}

.dp-create-placeholder__btn:hover:not(:disabled) {
  opacity: 0.9;
}

.dp-create-placeholder__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-create-placeholder__message {
  margin-top: var(--dp-spacing-sm);
  padding: var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
}

.dp-create-placeholder__message--success {
  background: #e8f5e9;
  color: #2e7d32;
}

.dp-create-placeholder__message--error {
  background: #fde8e8;
  color: var(--dp-color-error);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/CreatePlaceholder.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,mCAAmC;EACnC,mCAAmC;EACnC,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B","sourcesContent":[".dp-create-placeholder {\n  padding: var(--dp-spacing-md);\n}\n\n.dp-create-placeholder h3 {\n  margin: 0 0 var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-md);\n  color: var(--dp-color-text);\n}\n\n.dp-create-placeholder__desc {\n  margin: 0 0 var(--dp-spacing-md);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-create-placeholder__form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-sm);\n  margin-bottom: var(--dp-spacing-md);\n}\n\n.dp-create-placeholder__label {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text);\n  font-weight: var(--dp-font-weight-semibold);\n}\n\n.dp-create-placeholder__input,\n.dp-create-placeholder__select {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-normal);\n  color: var(--dp-color-text);\n  background: var(--dp-color-bg);\n}\n\n.dp-create-placeholder__input:focus,\n.dp-create-placeholder__select:focus {\n  outline: none;\n  border-color: var(--dp-color-primary);\n  box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.15);\n}\n\n.dp-create-placeholder__checkbox-label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n}\n\n.dp-create-placeholder__checkbox-label input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--dp-color-primary);\n}\n\n.dp-create-placeholder__btn {\n  width: 100%;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border: none;\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n}\n\n.dp-create-placeholder__btn:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.dp-create-placeholder__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-create-placeholder__message {\n  margin-top: var(--dp-spacing-sm);\n  padding: var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n}\n\n.dp-create-placeholder__message--success {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dp-create-placeholder__message--error {\n  background: #fde8e8;\n  color: var(--dp-color-error);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
